// Human labels for AI agent tools + router intents — shared by the live
// "thinking" sub-caption and the per-turn trace timeline so both stay in sync.

export const TOOL_LABELS = {
  get_user_context: 'Reading your context',
  query_data: 'Querying data',
  resolve_org: 'Finding the org',
  list_drive_files: 'Listing files',
  compare_payment_views: 'Comparing payment views',
  find_report: 'Searching reports',
  generate_csv_report: 'Generating CSV report',
  find_overdue_bills_by_vendor: 'Finding overdue bills',
  draft_email: 'Drafting email',
  draft_emails_batch: 'Drafting emails',
  approve_emails_batch: 'Approving emails',
  build_deep_link: 'Building a link',
  describe_page: 'Locating the page',
  create_task: 'Creating a task',
  create_note: 'Adding a note',
  reconcile_payments: 'Reconciling payments',
  analyze_document: 'Reading your document',
  onboard_collectors_from_file: 'Preparing collector onboarding',
  confirm_onboard_collectors: 'Onboarding collectors',
  get_collector_onboarding_status: 'Checking collector status',
  trigger_collectors: 'Triggering collection',
};

export const toolLabel = (name) =>
  TOOL_LABELS[name] || (name ? String(name).replace(/_/g, ' ') : 'Working');

export const INTENT_LABELS = {
  act: 'Action',
  investigate: 'Investigation',
  report: 'Report',
  status_check: 'Status check',
  navigate: 'Navigation',
  outreach: 'Outreach',
  bulk_approve: 'Bulk approve',
  answer: 'Answer',
  clarify: 'Clarify',
};

export const intentLabel = (i) =>
  INTENT_LABELS[i] || (i ? String(i).replace(/_/g, ' ') : '');
